import { GradientText, SplitText } from '@/components/GradientText.tsx';
import { Layout } from '@/components/Layout.tsx';
import { PageHero } from '@/components/PageHero.tsx';
import { ButtonLink, Eyebrow, Icons } from '@/components/ui.tsx';
import { NEWS_ITEMS } from '@/data/content.ts';
import { href } from '@/lib/paths.ts';

export function Newsroom() {
  return (
    <Layout currentPath="/newsroom">
      <PageHero
        image="images/hero-newsroom.webp"
        imageAlt=""
        width={1920}
        height={1280}
        eyebrow="In The Press"
        heading={
          <>
            The{' '}
            <GradientText as="em" immediate startDelay={0.5}>
              News Room
            </GradientText>
          </>
        }
        lead="Coverage and articles from leading financial and business publications about Lux Financial."
      />

      <section className="section-pad">
        <div className="container">
          <ul className="news-grid">
            {NEWS_ITEMS.map((item, i) => (
              <li
                key={item.href}
                className={`fade-in ${i === 1 ? 'fade-in-delay-1' : ''}`.trim()}
              >
                <article className="news-card">
                  <div className="news-card__source">{item.source}</div>
                  <div className="news-card__date">{item.date}</div>
                  <h3>{item.title}</h3>
                  <p>{item.excerpt}</p>
                  <a href={href(item.href)} className="news-card__link">
                    Read Article
                    <span className="sr-only">: {item.title}</span>
                    {Icons.arrowRight}
                  </a>
                </article>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="cta-section section-pad">
        <div className="container">
          <Eyebrow className="fade-in">Get Started</Eyebrow>
          <h2 className="fade-in fade-in-delay-1">
            <SplitText>Ready to Learn More?</SplitText>
          </h2>
          <p className="lead fade-in fade-in-delay-2">
            Speak with a member of our team and discover how Lux Financial can
            work for you.
          </p>
          <div className="cta-buttons fade-in fade-in-delay-3">
            <ButtonLink to="/#contact">Schedule a Consultation</ButtonLink>
            <ButtonLink to="/about" variant="outline">
              Meet Our Team
            </ButtonLink>
          </div>
        </div>
      </section>
    </Layout>
  );
}
